(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function(){

    const searchBtn = document.querySelector(".js-show-search");
    const searchBar = document.querySelector(".header__search");

    if(searchBtn && searchBar){

        searchBtn.addEventListener("click", function(e){

            if(window.innerWidth <= 767){
                e.preventDefault();
                searchBar.classList.toggle("active");
            }

        });

        document.addEventListener("click", function(e){

            if(window.innerWidth <= 767){

                if(!searchBar.contains(e.target) && !searchBtn.contains(e.target)){
                    searchBar.classList.remove("active");
                }

            }

        });

    }

    /* Mobile drawer close button inside drawer header */
    document.querySelectorAll(".mobile-drawer-close").forEach(function(closeBtn){
        closeBtn.addEventListener("click", function(){
            const disclosure = closeBtn.closest(".main-menu__disclosure");

            if(disclosure){
                const toggle = disclosure.querySelector(":scope > summary.main-menu__toggle");

                /* Use the original summary toggle so the theme resets
                   both the drawer state and hamburger/close icon state. */
                if(toggle && disclosure.open){
                    toggle.click();

                    window.requestAnimationFrame(function(){
                        toggle.focus();
                    });
                }
            }
        });
    });

});
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();
        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }
      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }
    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
